import { Basic } from 'src/app/core/models/basic.model';

export class ProductCategory extends Basic<string> {
    public tcea: number;
    public codeFilter: string;
    /**Url de archivo de Políticas de atención */
    //public attentionPolicyUrl: string;
    /**Url de archivo de Clausula de contrato */
    //public contractClauseUrl: string;
    /**Url de archivo de imagen */
    //public imageUrl: string;
    /**Url de archivo de imagen */
    //public active: boolean;
}